<div
  class="logo-loader"
  [class.full-screen]="fullScreen()"
  [class.no-backdrop]="backdrop() === false"
>
  <app-svg-icon [icon]="'assets/images/loader/logo.svg'" [blank]="true" />
</div>
